export const LOCAL_STORAGE_KEY = {
    LOCAL_USER_KEY: 'local_user',
    AMIRA_FEEDBACK_MESSAGE: 'AMIRA_FEEDBACK_MESSAGE',
    AMIRA_FEEDBACK_ELEMENT: 'AMIRA_FEEDBACK_ELEMENT',
    AMIRA_FEEDBACK_CONVERSATION_ID: 'AMIRA_FEEDBACK_CONVERSATION_ID',
    PROCESS_FEEDBACK_CALLBACK: 'PROCESS_FEEDBACK_CALLBACK',
    USER_LAST_UPDATED_TIMESTAMP: 'USER_LAST_UPDATED_TIMESTAMP',
};
export const SESSION_STORAGE_KEY = {
    FROM: 'from',
    TAFFI_STORE_DETAILS: 'taffi_store_details',
    TAFFI_STORE_SUGGESTED_QUESTIONS: 'taffi_store_suggested_questions',
    TAFFI_CONFIGURATION: 'taffi_configuration',
    TAFFI_APP_VERSION: 'taffi_app_version',
    TAFFI_AMIRA_STYLE_QUIZ_POPUP_DISPLAYED: 'taffi_amira_style_quiz_popup_displayed',
};
const PAGE_CODE = {
    CHAT: 'CHAT',
};

enum COLLECTION_NAME {
    STYLES = 'styles',
}

enum DIRECTIONS {
    LTR = 'ltr',
    RTL = 'rtl',
}

enum CUSTOM_OPTIONS {
    OTHER = 'Other',
}

enum ORDER_BY {
    CREATED_DESC = 'created desc',
    UPDATED_DESC = 'updated desc',
}

const BLINK_INTERVAL = 2000;
/* when updating BLINK_INTERVAL, please update corresponding css too */

const TYPE_WRITER_DELAY = 1;

const UNSUPPORTED_BROWSERS_FOR_SOCIAL_AUTH = [
    'chromium-webview', //instagram app of android
    'instagram', //instagram app of ios
    'ios-webview', //linkedin app of ios
];

export const API_ERROR_MESSAGE = {
    API_LIMIT_EXCEEDED: 'API_LIMIT_EXCEEDED',
};

const constant = {
    COLLECTION_NAME,
    CUSTOM_OPTIONS,
    UNSUPPORTED_BROWSERS_FOR_SOCIAL_AUTH,
    ORDER_BY,
    TAFFI_DOMAIN: ['taffi', 'localhost'],
    BLINK_INTERVAL,
    DIRECTIONS,
    TYPE_WRITER_DELAY,
    API_ERROR_MESSAGE,
    PAGE_CODE,
};

export default constant;
